<template>
  <div>
    <medicalPc v-if="!_isMobile"></medicalPc>
    <medicalMobile v-else></medicalMobile>
    <customizedService v-if="!_isMobile" text="合作联系"></customizedService>
  </div>
</template>

<script>
  import medicalPc from './pc/medicalPc.vue'
  import medicalMobile from './mobile/medicalMobile.vue'
  import customizedService from '../components/customizedServicePc.vue'
  export default {
     metaInfo(){
      return {
        meta:[
          {
            name: 'title',
            content: '优加健保健康科技 ( 北京 ) 有限公司'
          },
          {
            name:'keywords',
            content:'优加健康,优加健保健康科技 ( 北京 ) 有限公司,医疗保险,创新医疗险,技术团队'
          },
          {
            name: 'description',
            content: '优加健康 一支既懂医疗又懂保险的专业化团队 针对创新医疗险的产品/服务创新和落地能力,服务覆盖百万人群。 针对商保的医疗式专家型管理服务团队,行业权威协会和专业院校共同培训及认证。 精通健康险及互联网数据运营的产品及技术团队。'
          }
        ]
      }
    },
    data() {
      return {
        _isMobile: false
      }
    },
    components: {
      medicalPc,
      medicalMobile,
      customizedService
    },
    created() {
      this._isMobile = this.$util._isMobile()
    },
  }
</script>

<style lang="less" scoped>
  .made {
    width: 100%;

    img {
      width: 100%;
    }
  }
  .madeMobile{
    height: 5.4rem;
  }
</style>


// WEBPACK FOOTER //
// src/views/medical.vue